<input
  #inp
  class="form-control"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [attr.placeholder]="props['placeholder']"
  [attr.autocomplete]="props['autocomplete'] || 'off'"
  [readonly]="props.readonly"
  (input)="onInput($event)"
  (blur)="onBlur()"
  (focus)="onFocus()"
  [class.is-invalid]="formControl.invalid && (formControl.touched || formControl.dirty)"
/>